import { Producto } from "./producto";
import { Lote } from "./lote";

export class VentaDetalle{
    public constructor(
        public id: String = "",
        public cantidad: number = 0,
        public descripcion: String = "",
        public codigo: String = "",
        public producto: Producto = new Producto(),
        public lote: Lote = new Lote(),
        public unidad: String = "",
        public imagen: String = "",
        //

        public series: Array<any> = [],
        public codigos_series: Array<string> = [],
        // public es_servicio: boolean = false,
        public tipo_producto_id: string = "",
        public if_uso_lote:boolean = null,
        public cantidad_stock: number = 0,
        public precio_unitario: number = 0,
        public graba_iva: boolean = false,
        public desc_valor: number = 0,
        public desc_porcent: number = 0,
        public subtotal: number = 0,
        public iva:number = 0,
        public porct_iva: number = 0,
        public total: number = 0,
        public detalle: String = "",
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public compra_id: String = "",
        public producto_id: String = "",
        public lote_id:String = "", 
        public usuario_id:String = null,

        public cuenta_inventario_id: String = "",
        public cuenta_ingreso_id: String = "",
        public cuenta_costo_gasto_id: String = "",
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/venta_detalle.ts